var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CampaignsListCard',_vm._b({},'CampaignsListCard',{ campaigns: _vm.campaigns, routeToCampaign: _vm.routeToCampaign },false))
}
var staticRenderFns = []

export { render, staticRenderFns }